<template>
    <div class="">
        <div v-show="!open" class="inline-block">
            <span
                v-for="tag in selectedTags"
                :key="tag.id"
                class="mr-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
            >
                <input type="hidden" name="tags[]" :value="tag.id" />
                {{ tag.display_name }}
            </span>
        </div>
        <div v-if="open" class="inline-block">
            <span
                v-for="tag in tags"
                :key="tag.id"
                @click="toggle(tag.id)"
                :class="selected.includes(tag.id) ? 'bg-indigo-100 text-indigo-800' : 'bg-gray-100 text-gray-600'"
                class="cursor-pointer mr-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
            >
                <span v-if="tag.description === null">
                    {{ tag.display_name }}
                </span>
                <abbr v-else :title="tag.description">
                    {{ tag.display_name }}
                </abbr>
                <span v-if="withCount && tag.student_files_count">&nbsp;({{ tag.student_files_count }})</span>
            </span>
        </div>
        <div class="inline-block">
            <svg
                @click="open = !open"
                :class="open ? 'rotate-90' : ''"
                class="text-indigo-600 w-6 h-6 ease-in-out duration-150"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selected: [],
            open: false,
        };
    },
    props: {
        tags: {
            type: Array,
            required: true,
        },
        inputSelectedTags: {
            type: Array,
            required: true,
        },
        defaultOpen: {
            type: Boolean,
            required: false,
        },
        withCount: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    computed: {
        selectedTags: function () {
            return this.tags.filter((t) => this.selected.includes(t.id));
        },
    },
    methods: {
        toggle(id) {
            if (this.selected.includes(id)) {
                this.selected.splice(this.selected.indexOf(id), 1);
            } else {
                this.selected.push(id);
            }
        },
    },
    created() {
        this.selected = this.inputSelectedTags.map((t) => +t);
        this.open = this.defaultOpen;
    },
};
</script>
